


<!--************************Breadcrumbs div***********************************-->
<div style="background-color: #dedede;line-height: 0px;">
        <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
                        font-size: 12px;margin-bottom: 0 !important;">
            <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
                <a (click)="goToPageLink(item.page_ref)">
                    {{ item.page_title }}
                </a>
            </li>
        </ol>
    </div>
    <!--************************Breadcrumbs div***********************************-->
    
    <mat-toolbar>
        <h6 class="show-title">{{showEditUsertxt}}</h6>
        <button class="more-btn-custom" mat-raised-button (click)="addDevice()">
            <i class="material-icons icon-layout-custom">add_circle</i>
            &nbsp;
            Add New
        </button>
    </mat-toolbar>
    
    <div fxLayoutAlign="center center" class="form_outer" fxLayout="column" style="padding: 16px;">
    
        <form [formGroup]="uForm" (ngSubmit)="saveAsstes()">
            <div class="form_field_outer">
                <mat-form-field class="example-full-width" floatLabel="always">
                    <input matInput placeholder="Motor Make*" type="text" formControlName="motor_make" id="motor_make">
                    <!-- <mat-placeholder class="placeholder">Motor Make*</mat-placeholder> -->
                </mat-form-field>
                <!--<control-messages class="error_msg" [control]="uForm.controls.motor_make"></control-messages>-->
            </div>
    
    
    
            <div class="col-sm-12 no_padding frame_temp_outer">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form_field_outer">
                            <mat-form-field class="example-full-width" floatLabel="always">
                                <input matInput placeholder="Frame" type="number" formControlName="frame" id="frame">
                                <!-- <mat-placeholder class="placeholder">Frame</mat-placeholder> -->
                            </mat-form-field>
                            <!--<control-messages class="error_msg" [control]="uForm.controls.frame"></control-messages>-->
                        </div>
                        <span class="litre_txt"> Litre</span>
                    </div>
                    <div class="col-sm-6">
                        <div class="form_field_outer width_200">
                            <mat-form-field class="example-full-width" floatLabel="always">
                                <input matInput type="number" placeholder="Rated Ambient Temperature" formControlName="ambient_temperature"
                                    id="ambient_temperature">
                                <!-- <mat-placeholder class="placeholder">Rated Ambient Temperature</mat-placeholder> -->
                            </mat-form-field>
                            <!--<control-messages class="error_msg" [control]="uForm.controls.ambient_temperature">-->
                            <!--</control-messages>-->
                        </div>
                        <mat-radio-group aria-label="Select an option" formControlName="temperature_sy" id="temperature_sy"
                            class="amb_temp_unit">
                            <mat-radio-button value="C"> ̊C</mat-radio-button>
                            <mat-radio-button value="F">F</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
    
    
            <div class="form_field_outer">
                <mat-form-field class="example-full-width" floatLabel="always">
                    <input matInput type="text" placeholder="Insulation Class" formControlName="insulation_class" id="insulation_class">
                    <!-- <mat-placeholder class="placeholder">Insulation Class</mat-placeholder> -->
                </mat-form-field>
                <!--<control-messages class="error_msg" [control]="uForm.controls.insulation_class"></control-messages>-->
            </div>
    
    
            <div class="form_field_outer">
                <mat-form-field class="example-full-width" floatLabel="always">
                    <input matInput type="text" placeholder="Motor Serial #" formControlName="motor_serial" id="motor_serial">
                    <!-- <mat-placeholder class="placeholder">Motor Serial #</mat-placeholder> -->
                </mat-form-field>
                <!--<control-messages class="error_msg" [control]="uForm.controls.motor_serial"></control-messages>-->
            </div>
    
            <div class="rated_power_outer">
                <div class="form_field_outer">
                    <mat-form-field class="example-full-width" floatLabel="always">
                        <input matInput type="number" formControlName="rated_power" id="rated_power">
                        <!-- <mat-placeholder class="placeholder">Rated Power</mat-placeholder> -->
                    </mat-form-field>
                    <!--<control-messages class="error_msg" [control]="uForm.controls.rated_power"></control-messages>-->
                </div>
                <mat-radio-group aria-label="Select an option" formControlName="power_unit" id="power_unit" class="powunit">
                    <mat-radio-button value="KW"> KW</mat-radio-button>
                    <mat-radio-button value="HP">HP</mat-radio-button>
                </mat-radio-group>
            </div>
    
    
            <div class="form_field_outer">
                <mat-form-field class="example-full-width" floatLabel="always">
                    <input matInput type="number" placeholder="Rated RPM" formControlName="rated_rpm" id="rated_rpm">
                    <!-- <mat-placeholder class="placeholder">Rated RPM</mat-placeholder> -->
                </mat-form-field>
                <!--<control-messages class="error_msg" [control]="uForm.controls.rated_rpm"></control-messages>-->
            </div>
    
    
            <div class="form_field_outer">
                <mat-form-field class="example-full-width" floatLabel="always">
                    <input matInput type="text" placeholder="Rated Voltage" formControlName="rated_voltage" id="rated_voltage">
                    <!-- <mat-placeholder class="placeholder">Rated Voltage</mat-placeholder> -->
                </mat-form-field>
                <!--<control-messages class="error_msg" [control]="uForm.controls.rated_voltage"></control-messages>-->
            </div>
    
    
            <div class="form_field_outer">
                <mat-form-field class="example-full-width" floatLabel="always">
                    <input matInput type="text" placeholder="Percentage efficiency" formControlName="efficiency" id="efficiency">
                    <!-- <mat-placeholder class="placeholder">Percentage efficiency</mat-placeholder> -->
                </mat-form-field>
                <!--<control-messages class="error_msg" [control]="uForm.controls.efficiency"></control-messages>-->
            </div>
    
    
            <div class="form_field_outer">
                <mat-form-field class="example-full-width" floatLabel="always">
                    <input matInput type="number" placeholder="Power Factor" formControlName="power_factor" id="power_factor">
                    <!-- <mat-placeholder class="placeholder">Power Factor </mat-placeholder> -->
                </mat-form-field>
                <!--<control-messages class="error_msg" [control]="uForm.controls.power_factor"></control-messages>-->
            </div>
    
            <div class="form_field_outer">
                <mat-form-field class="example-full-width" floatLabel="always">
                    <input matInput type="text" placeholder="Duty" formControlName="duty" id="duty">
                    <!-- <mat-placeholder class="placeholder">Duty</mat-placeholder> -->
                </mat-form-field>
                <!--<control-messages class="error_msg" [control]="uForm.controls.duty"></control-messages>-->
            </div>
    
    
            <div class="all_select_outer">
                <mat-form-field class="example-full-width" floatLabel="always">
                    <mat-select placeholder="Site" formControlName="site_id" id="site_id"
                        (selectionChange)="selectSite($event.value)">
                        <mat-option [value]="site.id" *ngFor="let site of sitesList">
                            {{site.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
    
                <mat-form-field class="example-full-width" floatLabel="always">
                    <mat-select placeholder="Applications" (selectionChange)="selectGroup($event.value)" formControlName="application_id" id="application_id">
                        <mat-option [value]="group.id" *ngFor="let group of groupList;let idx = index;">
                            {{group.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width full_width" floatLabel="always">
                <mat-select placeholder="Device" formControlName="device_id" id="device_id">
                    <mat-option [value]="device.id" *ngFor="let device of allDevices">
                        {{device.mac_address}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
    
            <div class="btn-box text-center">
                <button *ngIf="showSavebtn" mat-raised-button style="border-radius: 50px;" type="submit"
                    [disabled]="!uForm.valid">Save</button>
                <button *ngIf="showUpdateBtn" mat-raised-button style="border-radius: 50px;"
                    (click)="saveDevice()">Update</button>
            </div>
        </form>
    </div>
















<!-- ************************Breadcrumbs div***********************************
<div style="background-color: #dedede;line-height: 0px;">
    <ol class="breadcrumb" style="background: transparent;
              font-size: 12px;margin-bottom: 0 !important;">
        <li class="breadcrumb-item" *ngFor="let item of breadcrumbsArray; let i = index">
            <a (click)="goToPageLink(item)">
                {{ item }}
            </a>
        </li>
    </ol>
</div>


<mat-toolbar>
    <h6 class="show-title">{{showEditUsertxt}}</h6>
    <button class="more-btn-custom" mat-raised-button (click)="addDevice()">
        <i class="material-icons icon-layout-custom">add_circle</i>
        &nbsp;
        Add New
    </button>
</mat-toolbar>

<div fxLayoutAlign="center center" fxLayout="column" style="padding: 16px; margin-bottom: 100px;">
    <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="text">
        <mat-placeholder class="placeholder">Motor Make</mat-placeholder>
    </mat-form-field>
    <div class="col-sm-6 no_padding frame_temp_outer">
        <div class="row">
            <div class="col-sm-6">
                <mat-form-field class="example-full-width frame_field" floatLabel="always">
                    <input matInput type="number">
                    <mat-placeholder class="placeholder">Frame</mat-placeholder>
                </mat-form-field>
                <span class="litre_txt"> Litre</span>
            </div>
            <div class="col-sm-6">
                <mat-form-field class="example-full-width rated_temp_field" floatLabel="always">
                    <input matInput type="number">
                    <mat-placeholder class="placeholder">Rated Ambient Temperature</mat-placeholder>
                </mat-form-field>
                <mat-radio-group aria-label="Select an option">
                    <mat-radio-button value="1"> ̊C</mat-radio-button>
                    <mat-radio-button value="2">F</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>


    <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="text">
        <mat-placeholder class="placeholder">Insulation Class</mat-placeholder>
    </mat-form-field>



    <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="text">
        <mat-placeholder class="placeholder">Motor Serial #</mat-placeholder>
    </mat-form-field>

    <div class="rated_power_outer">
        <mat-form-field class="example-full-width" floatLabel="always">
            <input matInput type="number">
            <mat-placeholder class="placeholder">Rated Power</mat-placeholder>
        </mat-form-field>
        <mat-radio-group aria-label="Select an option">
            <mat-radio-button value="1"> KW</mat-radio-button>
            <mat-radio-button value="2">HP</mat-radio-button>
        </mat-radio-group>
    </div>

    <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="number">
        <mat-placeholder class="placeholder">Rated RPM</mat-placeholder>
    </mat-form-field>

    <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="text">
        <mat-placeholder class="placeholder">Rated Voltage </mat-placeholder>
    </mat-form-field>

    <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="number">
        <mat-placeholder class="placeholder">Power Factor </mat-placeholder>
    </mat-form-field>


    <div class="all_select_outer">
        <mat-form-field class="example-full-width" floatLabel="always">
            <mat-select placeholder="Site">
                <mat-option>
                    Option 1
                </mat-option>
                <mat-option>
                    Option 2
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="example-full-width" floatLabel="always">
            <mat-select placeholder="Group">
                <mat-option>
                    Option 1
                </mat-option>
                <mat-option>
                    Option 2
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-form-field class="example-full-width" floatLabel="always">
        <mat-select placeholder="Device">
            <mat-option>
                Option 1
            </mat-option>
            <mat-option>
                Option 2
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="btn-box">
        <button *ngIf="showSavebtn" mat-raised-button style="border-radius: 50px;" (click)="saveDevice()">Save</button>
        <button *ngIf="showUpdateBtn" mat-raised-button style="border-radius: 50px;"
            (click)="saveDevice()">Update</button>
    </div>

</div> -->
